module.exports = __webpack_public_path__ + "img/bloom_light_natural_ba_list.3ff65599.jpg";